module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.isEmailValid === _vm.checkValues.INVALID
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.tokens['email_id'],
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._m(0), (_vm.isEmailValid === _vm.checkValues.INVALID) ? _c('span', {
    staticClass: "icon is-small is-right"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]) : _vm._e()]), _c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.isPasswordValid === _vm.checkValues.INVALID
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.tokens['password']
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._m(1), (_vm.isPasswordValid === _vm.checkValues.INVALID) ? _c('span', {
    staticClass: "icon is-small is-right"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]) : _vm._e()]), _c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canLogIn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Log in")])]), _c('p')]), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-user-secret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f310dde"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Login.vue
// module id = 408
// module chunks = 0